import { render, staticRenderFns } from "./ReportSectorList.vue?vue&type=template&id=4106b010&scoped=true"
import script from "./ReportSectorList.vue?vue&type=script&lang=js"
export * from "./ReportSectorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4106b010",
  null
  
)

export default component.exports